import { DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLoadUnloadCodes extends Layout {
    panelActive: Panel;
    panelInfo: Panel;
    sourceLoadUnload: DataSource;
    switchActive: Switch;
    textboxCompletionTime: Textbox;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
